import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Por fin pude dormir sin revisar el celular. Es un antes y un después.',
  name: 'Julieta R.',
  location: 'Córdoba',
  initials: 'JR'
}, {
  quote: 'Pensé que era imposible dejar de mirar su Instagram. El Protocolo del Búnker Digital fue lo único que me funcionó de verdad.',
  name: 'Micaela G.',
  location: 'Rosario',
  initials: 'MG'
}, {
  quote: 'El precio es nada comparado con volver a dormir tranquila. Gracias por devolverme el mando de mi vida.',
  name: 'Sofía P.',
  location: 'CABA',
  initials: 'SP'
}, {
  quote: 'La bitácora me hizo ver el patrón. Día 3 y ya no sentía la urgencia de revisar su perfil. Es como despertar de un hechizo.',
  name: 'Valentina M.',
  location: 'Mendoza',
  initials: 'VM'
}];
function Stars() {
  return <div className="flex gap-0.5 mb-2" data-id="element-140">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 text-gold fill-gold" strokeWidth={0} data-id="element-141" />)}
    </div>;
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8
    }
  }
};
export function Testimonials() {
  return <section className="py-5 px-6 bg-black border-t border-gold/10" data-id="element-142">
      <div className="max-w-5xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="text-center mb-4" data-id="element-144">
          <p className="font-sans text-[10px] text-gold uppercase tracking-[0.3em] mb-2" data-id="element-145">
            Lo que dicen las mujeres
          </p>
          <h2 className="font-cinzel text-3xl md:text-4xl text-white tracking-[0.1em]" data-id="element-146">
            RESULTADOS <span className="text-gold" data-id="element-147">REALES</span>
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-148">
          {testimonials.map((t, i) => <motion.div key={i} variants={itemVariants} className="border border-white/5 p-4 sm:p-5 text-center" data-id="element-149">
              <Stars data-id="element-150" />
              <p className="font-sans text-sm text-gray-400 font-light leading-loose italic mb-3" data-id="element-151">
                "{t.quote}"
              </p>
              <div className="flex flex-col items-center" data-id="element-152">
                <div className="w-9 h-9 rounded-full border border-gold/20 flex items-center justify-center mb-1" data-id="element-153">
                  <span className="font-sans text-[10px] text-white/70 tracking-widest" data-id="element-154">
                    {t.initials}
                  </span>
                </div>
                <span className="font-cinzel text-sm text-white tracking-widest" data-id="element-155">
                  {t.name}
                </span>
                <span className="font-sans text-[10px] text-gold/40 tracking-[0.2em] uppercase mt-0.5" data-id="element-156">
                  {t.location}, Argentina
                </span>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}